import { createType } from 'framework/utils/createType';

export const StockTransactionTabTypes = createType('deliveries', 'returns', 'stock-movements');
export type StockTransactionTabType = typeof StockTransactionTabTypes[number];
